import React from 'react'
import TextInput from './inputs/TextInput'
// import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
// import {Control} from 'react-redux-form'

class CompetencySubForm extends React.Component {
  render() {
    const {competency, numOfCols, totalRatio, base, handleCompetency} = this.props
    const {id, name, ratio, invalid} = competency
    return (
      <Grid container>
        <Grid container item xl={numOfCols}>
          <div className="d-flex align-items-center cefr-level-wrapper">
            <span className="cefr-level fw-bold body1 level-name" style={{minWidth: 120}}>{name}</span>
            <div className="small-input">
              <TextInput
                id={`${base}-ratio-${name}`}
                nocontrol={true}
                multiline={true}
                value={ratio}
                error={base === "preview" ? false : invalid}
                required
                helperText={`Ratio (${totalRatio > 0 ? (100.0*(ratio/totalRatio)).toFixed(2) : "0.00"}%)`}
                onChange={e=> {
                  handleCompetency(e, id, "ratio")
                }}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    )
  }
}

export default CompetencySubForm



// WEBPACK FOOTER //
// ./src/js/components/CompetencySubForm.js